import PropTypes from "prop-types";
import { Paper, Typography, Skeleton, Grid, Stack } from "@mui/material";

export default function PayPlanAssignmentsLoader(props) {
	const { positionTitle = false, addSelector = false, amount = 6 } = props;

	return (
		<Paper elevation={0} sx={{ marginTop: "20px" }} className="section">
			{positionTitle ? (
				<Typography
					sx={{
						paddingLeft: "15px",
						fontSize: "20px !important",
					}}
				>
					<Skeleton
						sx={{
							borderRadius: "4px",
						}}
						animation="wave"
						variant="rectangular"
						width={170}
					/>
				</Typography>
			) : null}
			<Grid
				container
				columnSpacing={8}
				spacing={2}
				sx={{
					padding: `20px ${addSelector ? "26px" : "16px"}`,
				}}
			>
				{Array(amount)
					.fill(amount)
					.map((_e, i) => {
						const itemKey = `item-${i}`;
						return (
							<Grid key={itemKey} xs={4} item>
								{addSelector ? (
									<Stack mb={1} ml={-3} spacing={0.8} direction="row">
										<Skeleton
											sx={{
												borderRadius: "3px",
											}}
											animation="wave"
											variant="rectangular"
											width={18}
											height={18}
										/>
										<Skeleton
											sx={{
												marginBottom: "7px",
												borderRadius: "3px",
											}}
											animation="wave"
											variant="rectangular"
											width={140}
											height={18}
										/>
									</Stack>
								) : (
									<Skeleton
										sx={{
											marginBottom: "7px",
											borderRadius: "4px",
										}}
										animation="wave"
										variant="rectangular"
										width={140}
										height={18}
									/>
								)}

								<Skeleton
									sx={{
										borderRadius: "4px",
									}}
									animation="wave"
									variant="rectangular"
									width={200}
									height={150}
								/>
							</Grid>
						);
					})}
			</Grid>
		</Paper>
	);
}
PayPlanAssignmentsLoader.propTypes = {
	positionTitle: PropTypes.bool,
	addSelector: PropTypes.bool,
	amount: PropTypes.number,
};
